import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Revert = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Revert' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M8,3 L3,8 L8,13 M12,20 L15,20 C18.3137085,20 21,17.3137085 21,14 C21,10.6862915 18.3137085,8 15,8 L4,8' />
  </StyledIcon>
);
